"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = require("@emotion/styled");
const theme_1 = require("../theme");
const loadingSpinnerUrl = require("./loading-spinner.svg");
const shadowHeight = '3px';
const buttonHeight = '40px';
const shadow = `0 ${shadowHeight} 0 0 rgba(181, 181, 181, 0.5)`;
exports.StyledButton = styled_1.default.button `
	background-color: ${props => props.bgColor};
	color: ${props => props.color};
	font-size: ${theme_1.default.typography.styles.c1.size};
	line-height: ${theme_1.default.typography.styles.c1.height};
	display: inline-flex;
	align-items: center;
	text-decoration: none;
	outline: none;
	position: relative;
	height: ${buttonHeight};
	border: none;
	border-radius: ${theme_1.default.layout.radius.squared};
	padding: ${theme_1.default.spacing.small} ${theme_1.default.spacing.large};
	overflow: hidden;
	opacity: ${props => props.disabled ? 0.5 : 1};
	box-shadow: ${shadow};
	transition: background-color ${theme_1.default.motion.transition.default}, box-shadow ${theme_1.default.motion.transition.default};
	-moz-osx-font-smoothing: grayscale;
	-webkit-font-smoothing: antialiased;
	margin-bottom: ${shadowHeight};
	cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
	white-space: nowrap;

	:hover {
		box-shadow: none;
		background-color: ${props => props.hoverColor};
	}

	:focus,
	:active {
		box-shadow: none;
		background-color: ${props => props.activeColor};
	}

/* === Icon text === */

& .button__icon {
	font-family: 'TravelNest';
	display: inline-block;
}

& .button__icon--before {
	margin-right: ${theme_1.default.spacing.small};
}

& .button__icon--after {
	margin-left: ${theme_1.default.spacing.small};
}

/* === Loading === */

&.button--loading,
&.button--loading:active,
&.button--loading:focus,
&.button--loading:hover {
	background-color: ${theme_1.default.colours.neutral.light};
	color: ${theme_1.default.colours.neutral.dark};
	border: none;
	cursor: auto;
	box-shadow: ${shadow};

}

@keyframes button-loader-spin {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(0deg);
	}
}

& > .button__loader {
	background-image: url(${loadingSpinnerUrl});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
	transform: rotate(0deg);
	animation: button-loader-spin 1s linear;
	height: 85%;
	filter: grayscale(1);
	position: absolute;
	width: 100%;
	right: 0px;
	top: 10%;
}

& > .button__content--hidden {
	visibility: hidden;
}`;
//# sourceMappingURL=button.styled.js.map